import React, {Component} from 'react'
import {DatePicker} from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'

const {RangePicker} = DatePicker

class FilterDateRangeV2 extends Component {
    _handleDateChange = (date, dateString) => {
        const [from, to] = dateString
        const {field, onDatesChange} = this.props

        onDatesChange(field, {from, to})
    }

    _renderClassName = () => {
        const {className} = this.props
        const strClassName = className + ''

        const trimClassName = strClassName.trim()

        if (!trimClassName) {
            return 'FilterDateRange'
        }

        return `FilterDateRange ${trimClassName}`
    }

    render() {
        const {heading, showTime, disabled, value} = this.props
        const wrapperClass = this._renderClassName()
        const DATE_FORMAT = showTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'

        return (
            <div className={wrapperClass}>
                {
                    heading &&
                    <div className='font-weight-500 mb-2'>{heading}</div>
                }

                <RangePicker
                    ranges={{
                        'Today': [moment().startOf('day'), moment().endOf('day')],
                        'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                    }}
                    format={DATE_FORMAT}
                    showTime={showTime ? {
                        hideDisabledOptions: true,
                        format: 'HH:mm',
                        defaultValue: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')],
                    } : showTime}
                    onChange={this._handleDateChange}
                    disabled={disabled || false}
                    {...(!!value ? {
                        value: value?.from && value?.to ? [
                            moment(value.from, 'DD/MM/YYYY HH:mm'),
                            moment(value.to, 'DD/MM/YYYY HH:mm')
                        ] : false
                    } : {})}
                />
            </div>
        )
    }
}

FilterDateRangeV2.propTypes = {
    heading: PropTypes.string,
    className: PropTypes.string,
    field: PropTypes.string.isRequired,
    onDatesChange: PropTypes.func.isRequired,
}

export default FilterDateRangeV2
